import { Button } from "@/components/ui/button";
import { useConnectivity } from "../contexts/ConnectivityContext.jsx";

// Shown once per offline transition (ConnectivityContext only flips showOfflineAlert on a
// true→false edge, not on every poll) — local work isn't blocked by being offline, so this is
// informational, not a hard gate: "Продолжить" just dismisses it.
export default function OfflineAlert() {
  const { showOfflineAlert, dismissOfflineAlert, recheck, recheckPending } = useConnectivity();
  if (!showOfflineAlert) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-[300] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-[380px] max-w-[95vw] overflow-hidden">
        <div className="px-5 py-4">
          <div className="text-base font-bold text-slate-900 mb-1.5">Оффлайн режим</div>
          <div className="text-sm text-slate-600">
            Нет связи с центральным сервером. Сканирование и сохранение работают локально как
            обычно — данные синхронизируются автоматически, как только связь восстановится.
          </div>
        </div>
        <div className="flex justify-end gap-2 px-5 py-3 border-t border-slate-100">
          <Button variant="ghost" onClick={dismissOfflineAlert}>Продолжить</Button>
          <Button onClick={() => recheck().then(r => { if (r.online) dismissOfflineAlert(); })} disabled={recheckPending}>
            {recheckPending ? "Проверка..." : "Повторить"}
          </Button>
        </div>
      </div>
    </div>
  );
}
